import {
  Avatar,
  Box,
  Stack,
  Typography,
  IconButton,
  Grid,
  Button,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableRow,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import React, { useContext, useEffect, useState } from 'react';
import User from 'assets/icons/UserProfile.svg';
import Monetize from 'assets/icons/dollar.svg';
import Detoast from 'assets/icons/detoast.svg';
import BlueTick from 'assets/icons/blueTick.svg';
import FHB from 'assets/icons/fhb.svg';
import Phone from 'assets/icons/callPhone.svg';
import Location from 'assets/icons/locationMap.svg';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import Mail from 'assets/icons/mail.svg';
import BuyerReadiness from 'assets/images/buyerReadiness.jpg';
import CircularProgress from '@mui/material/CircularProgress';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { displayFlex } from 'component/ActivityContainer/ActivityContainer.style';
import Loading from 'assets/images/loading.png';
import {
  fontsize14,
  poppins300,
  poppins400,
  poppins500,
  poppins600,
  menuitemfont,
} from 'theme/common.style';
import {
  Arrow2,
  ExpandIcon,
  IOSSwitch,
  RightArrow,
} from 'component/OwnerCard/OwnerCard';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import { getApiCall } from 'api/apiService';
import { GET_BuyersCard } from 'constant/app.config';
import { toast } from 'react-toastify';
import BadgeButton from './components/BadgeButton';
import { matchesProperty } from 'lodash';
import { Closeicon } from './BuyerRegisterCard';
import NameTooltip from 'component/Common/NameTooltip';
const Uparrow = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.52734 7.32446L7.72552 1.33895L13.711 7.53713"
        stroke="#9D9C9E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Downarrow = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8086 1.11328L7.71582 7.20606L1.62305 1.11328"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Upactivearrow = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: 'rotate(180deg)' }}
    >
      <path
        d="M13.8086 1.11328L7.71582 7.20606L1.62305 1.11328"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Downinactivearrow = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: 'rotate(180deg)' }}
    >
      <path
        d="M1.52734 7.32446L7.72552 1.33895L13.711 7.53713"
        stroke="#9D9C9E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const ExpIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.7626 6.80661C14.7626 9.18634 12.8546 11.0945 10.4732 11.0945C8.0926 11.0945 6.18374 9.18634 6.18374 6.80661C6.18374 4.42688 8.0926 2.51953 10.4732 2.51953C12.8546 2.51953 14.7626 4.42688 14.7626 6.80661ZM10.4732 18.7245C6.95865 18.7245 3.99121 18.1533 3.99121 15.9494C3.99121 13.7447 6.97729 13.1937 10.4732 13.1937C13.9886 13.1937 16.9552 13.7649 16.9552 15.9689C16.9552 18.1736 13.9691 18.7245 10.4732 18.7245Z"
        fill="#F74646"
      />
    </svg>
  );
};
const SelectDownIcon = () => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.825889 0.695695C0.984164 0.534246 1.23184 0.519569 1.40637 0.651664L1.45637 0.695695L5.02865 4.33977L8.60092 0.695695C8.7592 0.534246 9.00687 0.519569 9.1814 0.651664L9.2314 0.695695C9.38968 0.857144 9.40407 1.10979 9.27457 1.28781L9.2314 1.33882L5.34388 5.3043C5.18561 5.46575 4.93794 5.48043 4.76341 5.34834L4.71341 5.3043L0.825889 1.33882C0.651787 1.16123 0.651787 0.873289 0.825889 0.695695Z"
        fill="#112347"
      />
    </svg>
  );
};
const ToggleOff = () => {
  return (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="gradient" gradientTransform="rotate(90)">
          <stop offset="0%" stop-color="rgba(108, 42, 210, 1)" />
          <stop offset="100%" stop-color="rgba(119, 207, 254, 1)" />
        </linearGradient>
      </defs>
      <rect
        width="41.54"
        x="0.460938"
        y="0.370605"
        height="24.3705"
        rx="12.1852"
        fill="url(#gradient)"
      />
      <ellipse
        cx="12.982"
        cy="12.5558"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
    </svg>
  );
};

const CircularChart = () => {
  return (
    <svg
      width="170"
      height="205"
      viewBox="0 0 170 205"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.3"
        cx="41.5"
        cy="41.5"
        r="41.5"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 135.863 96)"
        stroke="#C4C4C4"
        stroke-width="10"
        stroke-linecap="round"
      />
      <g filter="url(#filter0_d_21276_28388)">
        <path
          d="M94.3396 13C101.436 13 108.414 14.8176 114.607 18.2793C120.801 21.741 126.003 26.7313 129.718 32.774C133.433 38.8167 135.537 45.7101 135.828 52.7964C136.12 59.8826 134.589 66.9253 131.382 73.2522C128.176 79.5791 123.4 84.9791 117.512 88.9369C111.623 92.8948 104.818 95.2783 97.7459 95.8601C90.6735 96.4419 83.57 95.2025 77.1132 92.2603C70.6564 89.318 65.0618 84.771 60.8633 79.0533"
          stroke="url(#paint0_linear_21276_28388)"
          stroke-width="10"
          stroke-linecap="round"
        />
      </g>
      <rect x="91.8633" y="10" width="6" height="5" rx="2.5" fill="white" />
      <path
        d="M77.0451 53.736C76.5224 53.5307 76.1211 53.232 75.8411 52.84C75.5611 52.448 75.4211 51.972 75.4211 51.412C75.4211 50.908 75.5471 50.4553 75.7991 50.054C76.0511 49.6433 76.4244 49.3213 76.9191 49.088C77.4231 48.8453 78.0298 48.724 78.7391 48.724C79.4484 48.724 80.0504 48.8453 80.5451 49.088C81.0491 49.3213 81.4271 49.6433 81.6791 50.054C81.9404 50.4553 82.0711 50.908 82.0711 51.412C82.0711 51.9533 81.9264 52.4293 81.6371 52.84C81.3478 53.2413 80.9511 53.54 80.4471 53.736C81.0258 53.9133 81.4831 54.226 81.8191 54.674C82.1644 55.1127 82.3371 55.6447 82.3371 56.27C82.3371 56.8767 82.1878 57.4087 81.8891 57.866C81.5904 58.314 81.1658 58.664 80.6151 58.916C80.0738 59.1587 79.4484 59.28 78.7391 59.28C78.0298 59.28 77.4044 59.1587 76.8631 58.916C76.3311 58.664 75.9158 58.314 75.6171 57.866C75.3184 57.4087 75.1691 56.8767 75.1691 56.27C75.1691 55.6447 75.3371 55.108 75.6731 54.66C76.0091 54.212 76.4664 53.904 77.0451 53.736ZM80.8391 51.566C80.8391 50.9967 80.6524 50.558 80.2791 50.25C79.9058 49.942 79.3924 49.788 78.7391 49.788C78.0951 49.788 77.5864 49.942 77.2131 50.25C76.8398 50.558 76.6531 51.0013 76.6531 51.58C76.6531 52.1027 76.8444 52.5227 77.2271 52.84C77.6191 53.1573 78.1231 53.316 78.7391 53.316C79.3644 53.316 79.8684 53.1573 80.2511 52.84C80.6431 52.5133 80.8391 52.0887 80.8391 51.566ZM78.7391 54.296C78.0484 54.296 77.4838 54.4593 77.0451 54.786C76.6064 55.1033 76.3871 55.584 76.3871 56.228C76.3871 56.8253 76.5971 57.306 77.0171 57.67C77.4464 58.034 78.0204 58.216 78.7391 58.216C79.4578 58.216 80.0271 58.034 80.4471 57.67C80.8671 57.306 81.0771 56.8253 81.0771 56.228C81.0771 55.6027 80.8624 55.1267 80.4331 54.8C80.0038 54.464 79.4391 54.296 78.7391 54.296ZM83.8751 57.978C85.0605 57.026 85.9891 56.2467 86.6611 55.64C87.3331 55.024 87.8978 54.3847 88.3551 53.722C88.8218 53.05 89.0551 52.392 89.0551 51.748C89.0551 51.1413 88.9058 50.6653 88.6071 50.32C88.3178 49.9653 87.8465 49.788 87.1931 49.788C86.5585 49.788 86.0638 49.9887 85.7091 50.39C85.3638 50.782 85.1771 51.3093 85.1491 51.972H83.9171C83.9545 50.9267 84.2718 50.1193 84.8691 49.55C85.4665 48.9807 86.2365 48.696 87.1791 48.696C88.1405 48.696 88.9011 48.962 89.4611 49.494C90.0305 50.026 90.3151 50.7587 90.3151 51.692C90.3151 52.4667 90.0818 53.2227 89.6151 53.96C89.1578 54.688 88.6351 55.332 88.0471 55.892C87.4591 56.4427 86.7078 57.0867 85.7931 57.824H90.6091V58.888H83.8751V57.978ZM92.6979 59.084C92.4552 59.084 92.2499 59 92.0819 58.832C91.9139 58.664 91.8299 58.4587 91.8299 58.216C91.8299 57.9733 91.9139 57.768 92.0819 57.6C92.2499 57.432 92.4552 57.348 92.6979 57.348C92.9312 57.348 93.1272 57.432 93.2859 57.6C93.4539 57.768 93.5379 57.9733 93.5379 58.216C93.5379 58.4587 93.4539 58.664 93.2859 58.832C93.1272 59 92.9312 59.084 92.6979 59.084ZM94.9933 51.426C95.0587 50.5673 95.39 49.8953 95.9873 49.41C96.5847 48.9247 97.3593 48.682 98.3113 48.682C98.946 48.682 99.492 48.7987 99.9493 49.032C100.416 49.256 100.766 49.564 100.999 49.956C101.242 50.348 101.363 50.7913 101.363 51.286C101.363 51.8647 101.195 52.364 100.859 52.784C100.533 53.204 100.103 53.4747 99.5713 53.596V53.666C100.178 53.8153 100.659 54.1093 101.013 54.548C101.368 54.9867 101.545 55.5607 101.545 56.27C101.545 56.802 101.424 57.2827 101.181 57.712C100.939 58.132 100.575 58.4633 100.089 58.706C99.604 58.9487 99.0207 59.07 98.3393 59.07C97.35 59.07 96.538 58.8133 95.9033 58.3C95.2687 57.7773 94.914 57.04 94.8393 56.088H96.0713C96.1367 56.648 96.3653 57.1053 96.7573 57.46C97.1493 57.8147 97.672 57.992 98.3253 57.992C98.9787 57.992 99.4733 57.824 99.8093 57.488C100.155 57.1427 100.327 56.6993 100.327 56.158C100.327 55.458 100.094 54.954 99.6273 54.646C99.1607 54.338 98.456 54.184 97.5133 54.184H97.1913V53.12H97.5273C98.386 53.1107 99.0347 52.9707 99.4733 52.7C99.912 52.42 100.131 51.9907 100.131 51.412C100.131 50.9173 99.968 50.5207 99.6413 50.222C99.324 49.9233 98.8667 49.774 98.2693 49.774C97.6907 49.774 97.224 49.9233 96.8693 50.222C96.5147 50.5207 96.3047 50.922 96.2393 51.426H94.9933Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M107.64 51.16C107.64 50.5253 107.831 50.0213 108.214 49.648C108.596 49.2653 109.086 49.074 109.684 49.074C110.281 49.074 110.771 49.2653 111.154 49.648C111.536 50.0213 111.728 50.5253 111.728 51.16C111.728 51.804 111.536 52.3173 111.154 52.7C110.771 53.0733 110.281 53.26 109.684 53.26C109.086 53.26 108.596 53.0733 108.214 52.7C107.831 52.3173 107.64 51.804 107.64 51.16ZM115.816 49.228L110.146 59H108.886L114.556 49.228H115.816ZM109.684 49.858C109.366 49.858 109.114 49.97 108.928 50.194C108.75 50.4087 108.662 50.7307 108.662 51.16C108.662 51.5893 108.75 51.916 108.928 52.14C109.114 52.364 109.366 52.476 109.684 52.476C110.001 52.476 110.253 52.364 110.44 52.14C110.626 51.9067 110.72 51.58 110.72 51.16C110.72 50.7307 110.626 50.4087 110.44 50.194C110.253 49.97 110.001 49.858 109.684 49.858ZM113.002 57.068C113.002 56.424 113.193 55.9153 113.576 55.542C113.958 55.1593 114.448 54.968 115.046 54.968C115.643 54.968 116.128 55.1593 116.502 55.542C116.884 55.9153 117.076 56.424 117.076 57.068C117.076 57.7027 116.884 58.2113 116.502 58.594C116.128 58.9767 115.643 59.168 115.046 59.168C114.448 59.168 113.958 58.9813 113.576 58.608C113.193 58.2253 113.002 57.712 113.002 57.068ZM115.032 55.766C114.714 55.766 114.462 55.878 114.276 56.102C114.089 56.3167 113.996 56.6387 113.996 57.068C113.996 57.488 114.089 57.81 114.276 58.034C114.462 58.2487 114.714 58.356 115.032 58.356C115.349 58.356 115.601 58.2487 115.788 58.034C115.974 57.81 116.068 57.488 116.068 57.068C116.068 56.6387 115.974 56.3167 115.788 56.102C115.601 55.878 115.349 55.766 115.032 55.766Z"
        fill="black"
      />
      <defs>
        <filter
          id="filter0_d_21276_28388"
          x="0.143311"
          y="0.0400047"
          width="196.44"
          height="204.44"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="47.76" />
          <feGaussianBlur stdDeviation="27.86" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.203125 0 0 0 0 0.585 0 0 0 0 0.9375 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_21276_28388"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_21276_28388"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_21276_28388"
          x1="70.8095"
          y1="101.533"
          x2="67.7679"
          y2="-52.0167"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5FB1DF" />
          <stop offset="1" stop-color="#5FB1DF" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BuyerRegisterProfile = (props) => {
  const {
    buyerCardLoading,
    setbuyerDetails,
    isSmall,
    isSm,
    count,
    showBackdrop,
    selectedBuyers,
    setSelectedBuyers,
    selectedBuyerId,
    setSelectedBuyerId,
    marketShow,
    setMarketShow,
    buyerId,
    openOwner,
    setOpenOwner,
    open,
    setOpen,
    userType,
    onClick,
    expand,
    setExpand,
    show,
    setShow,
    isHiddenRightArrow,
    setIsHiddenRightArrow,
    userName,
    userMobile,
    userEmail,
    userAddress,
    userNoOfOffers,
    userPreviousOffer,
    data,
    rowData,
    selectCheckBox,
    isModalOpen,
    setIsModalOpen,
    setOpenbuyercard,
    openbuyercard,
    setArrayCollection,
    setPosition,
    setBuyerId,
    previous,
    position,
    collectId,
    arrayCollection,
    buyersId,
    setUserType,
    len,
    next,
  } = props;

  const { setLoaderConfig } = useContext(LoaderContext);
  const [profileDetails, setprofileDetails] = useState({});
  const [isHidden, setIsHidden] = useState(false);
  const [hideExpand, setHideExpand] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClicke = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosee = () => {
    setAnchorEl(null);
  };

  const LeftArrow = () => {
    return (
      <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="0.1"
          x="0.863281"
          y="0.5"
          width="29"
          height="29"
          rx="4.5"
          stroke="#112347"
        />
        <path
          d="M16.8867 8.375L10.7939 14.4678L16.8867 20.5605"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };

  const openn = Boolean(anchorEl);
  const id = openn ? 'simple-popover' : undefined;

  const tableData = data?.user;
  const currentPage = window.location.pathname;

  function toggleShow() {
    setShow(!show);
  }
  var buttonText = show ? (
    <Typography
      sx={{
        fontFamily: 'Poppins !important',
        fontStyle: 'normal !important',
        fontWeight: '600 !important',
        fontSize: '12px',
      }}
    >
      <Grid
        item
        sx={{
          display: 'flex',
          direction: 'row',
          spacing: '2',
          textTransform: 'capitalize',
        }}
      >
        <Grid item sx={{ pr: 1 }}>{`collapse  `}</Grid>
        <Grid item>
          <Arrow2 />
        </Grid>
      </Grid>
    </Typography>
  ) : (
    <Typography
      sx={{
        fontFamily: 'Poppins !important',
        fontStyle: 'normal !important',
        fontWeight: '600 !important',
        fontSize: '12px',
      }}
    >
      <Grid
        item
        sx={{
          display: 'flex',
          direction: 'row',
          spacing: '2',
          textTransform: 'capitalize',
        }}
      >
        {' '}
        <Grid item sx={{ pr: 1 }}>
          expand
        </Grid>{' '}
        <Grid item>
          <Arrow2 />
        </Grid>
      </Grid>
    </Typography>
  );

  function CircularProgressWithProfile(props) {
    const size = matchessm ? 78 : matches1000 ? 80 : 100;
    const thickness = matchessm ? 3 : 5;

    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        {/* Background Progress */}
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={thickness}
          size={size}
        />

        {/* Gradient Progress */}
        <CircularProgress
          variant="determinate"
          value={props.value}
          thickness={thickness}
          size={size}
          style={{
            color: 'transparent',
            position: 'absolute',
          }}
          classes={{
            circle: 'custom-gradient-circle', // Apply custom class for gradient
          }}
        />

        {/* Circular End Cap */}
        <Box
          sx={{
            width: `${thickness + thickness - 1}px`,
            height: `${thickness + thickness - 1}px`,
            borderRadius: '50%',
            backgroundColor: 'white',
            position: 'absolute',
            top: `calc(50% - ${size / 2 - 0.5}px)`,
            left: `calc(50% - ${thickness - 0.5}px)`,
          }}
        />

        {/* Text or Avatar */}
        <Box
          sx={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{
              color: '#000000',
              ...poppins400,
              fontSize: matchessm ? '12px' : matches1000 ? '12px' : '14px',
            }}
          >
            {Math.round(props?.value * 100) / 100}%
          </Typography>
        </Box>

        {/* Gradient Styles */}
        <style>
          {`
            .custom-gradient-circle {
              stroke: url(#gradient);
              stroke-linecap: round; /* Make ends rounded */
            }
          `}
        </style>
        <svg width="0" height="0">
          <defs>
            <linearGradient id="gradient" x1="1" x2="0" y1="0" y2="0">
              <stop offset="0%" stopColor="#5FB1DF" />
              <stop offset="100%" stopColor="#5FB1DF" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
    );
  }

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    position: 'relative',
    [`&.${linearProgressClasses.colorPrimary}`]: {
      background: '#F0F0F0',
      border: '0.81px solid',
      borderRadius: '7.5px',
      borderColor: '#F0F0F0',
      marginLeft: '10px',
      width: '100px',
      height: '10px',
    },
    [`& .${linearProgressClasses.bar}`]: {
      background: 'linear-gradient(90deg, #6C2AD2 60%, #2FCDFF 100%)',
      borderRadius: 2.42,
      transition: 'none',
    },
  }));

  const TextOverlay = styled(Typography)(({ theme, leftPosition }) => ({
    position: 'absolute',
    top: '50%',
    left: `${leftPosition}%`,
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
    fontSize: '10px',
    fontFamily: 'Poppins',
    color: '#FFFFFF',
    fontWeight: '400px',
    alignItems: 'center',
  }));

  function LinearProgressBarWithPercentage(props) {
    const rediness = props.rediness || 0;
    return (
      <div style={{ position: 'relative' }}>
        <BorderLinearProgress variant="determinate" value={props.value} />
      </div>
    );
  }

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches370 = useMediaQuery(theme.breakpoints.down(370));
  const matches870 = useMediaQuery(theme.breakpoints.down(870));
  const matches1000 = useMediaQuery(theme.breakpoints.down(1000));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '15px',
        width: matchessm ? '100%' : '365px',
        height: '540px',
        background: '#FFFFFF',
        borderRadius: '10px, 0px, 0px, 10px',
      }}
    >
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={
          expand && !matchessm
            ? 'right'
            : matchessm
            ? 'center'
            : 'space-between'
        }
        sx={{
          margin: '0',
          width: '90%',
          marginTop: matchessm ? '0px' : '0px',
        }}
      >
        {data?.user == null ? (
          <Box sx={{ width: '10px', height: '10px' }}></Box>
        ) : (
          <>
            {(isHidden && expand) || matchessm ? null : (
              <IconButton
                sx={{ zIndex: 1 }}
                onClick={() => {
                  setExpand(!expand);
                  setIsHidden(true);
                }}
              >
                <ExpandIcon />
              </IconButton>
            )}
          </>
        )}

        {userType === 'Both' && !matchessm && (
          <Stack
            justifyContent={'space-around'}
            direction={'row'}
            alignItems={'center'}
            spacing={2}
            position={'sticky'}
            sx={{ marginLeft: '2px', margin: '1px', marginTop: '-1px' }}
          >
            <Typography
              sx={{
                ...poppins400,
                fontSize: '12px',
                color: '#9C9C9C',
                marginLeft: '90px',
              }}
            >
              Buyer
            </Typography>
            <Typography
              onClick={() => {
                setOpen(!open);
                setOpenOwner(!openOwner);
              }}
              style={{
                cursor: 'pointer',
                marginTop: '5px',
                marginLeft: '15px',
              }}
            >
              <ToggleOff />
            </Typography>
            <Typography
              sx={{
                ...poppins400,
                fontSize: '12px',
                color: '#112347',
                marginLeft: '90px',
              }}
            >
              Owner
            </Typography>
          </Stack>
        )}

        <>
          {!matchessm &&
          (!expand || (matches870 && (showBackdrop || !showBackdrop))) ? (
            <IconButton
              onClick={() => {
                selectCheckBox(buyerId, 'updateId');
                setOpen(!open);
                setbuyerDetails({});
                setBuyerId('');
                setSelectedBuyerId('');
                {
                  showBackdrop &&
                    setSelectedBuyers((prevBuyers) => {
                      const filter = selectedBuyers.filter(
                        (buyer) => buyer != buyerId
                      );
                      return filter;
                    });
                }
              }}
            >
              <RightArrow />
            </IconButton>
          ) : null}
        </>
      </Stack>

      <Box
        sx={{
          width: matchessm ? '100%' : '90%',
          height: '110px',
          position: 'relative',
        }}
      >
        <Stack
          sx={{
            width: matchessm ? '100%' : '327px',
            height: '67px',
            marginTop: !matchessm ? '0px' : '5px',
            borderRadius: '10px',
            background: `linear-gradient(180deg, rgba(108, 42, 210, 0.5) 0%, rgba(117, 184, 247, 0.5) 100%)`,
          }}
          justifyContent={'center'}
          alignItems={'center'}
          display={'-webkit-inline-flex'}
        >
          {data?.user?.userProfile == '' || data?.user?.userProfile == null ? (
            <Avatar
              sx={{
                height: '91px',
                width: '91px',
                border: '4px solid #FFFFFF',
                marginTop: '60px',
                backgroundColor: '#666666',
                fontFamily: 'poppins',
                fontSize: '35px',
              }}
            >
              {data?.user?.userName?.charAt(0)?.toUpperCase()}
              {data?.user?.userSurName?.charAt(0)?.toUpperCase()}
            </Avatar>
          ) : (
            <Avatar
              style={{
                height: '91px',
                width: '91px',
                border: '4px solid #FFFFFF',
                marginTop: '60px',
              }}
              src={data?.user?.userProfile}
              alt={data?.user?.userName}
            />
          )}
        </Stack>
      </Box>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          width: matchessm ? '100%' : '335px',
          height: '30px',
          minWidth: 0,
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            width: matchessm ? 'calc(100% - 70px)' : '265px',
            minWidth: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <NameTooltip
            name={data?.user?.userName || ''}
            surname={data?.user?.userSurName || ''}
          >
            <Typography
              sx={{
                ...poppins600,
                fontSize: '20px',
                color: '#000000',
                display: 'block',
                width: '100%',
                minWidth: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                cursor: 'pointer',
                textAlign: 'center',
              }}
            >
              {!buyerCardLoading &&
                `${data?.user?.userName || ''} ${
                  data?.user?.userSurName || ''
                }`.trim()}
            </Typography>
          </NameTooltip>
        </Box>

        <Box
          sx={{
            marginLeft: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            flexShrink: 0,
            zIndex: 1,
          }}
        >
          {/* Blue Tick */}
          <Avatar
            alt=""
            src={BlueTick}
            sx={{
              width: '16px',
              height: '16px',
              flexShrink: 0,
            }}
          />

          {/* Monetize */}
          <Avatar
            alt=""
            src={Monetize}
            sx={{
              width: '16px',
              height: '16px',
              flexShrink: 0,
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0px',
        }}
      >
        <Typography sx={{ ...poppins400, fontSize: '12px', color: '#585858' }}>
          Buyer Readiness
        </Typography>
        <LinearProgressBarWithPercentage
          value={data?.rediness}
          rediness={data?.rediness}
        />
      </Box>

      <Table
        sx={{
          width: matchessm ? '85%' : '310px',
          justifyContent: 'space-between',
        }}
        spacing={3}
      >
        <TableBody>
          <TableRow>
            <TableCell
              align="left"
              style={{ width: '35%', borderBottom: 'none' }}
            >
              {data?.profile == '' || data?.exp == '' ? (
                ''
              ) : (
                <Box sx={{ display: 'flex', gap: '5px' }}>
                  {' '}
                  <Typography
                    sx={{ ...poppins400, fontSize: '14px', color: '#112347' }}
                  >
                    {data?.profile}
                  </Typography>
                  <ExpIcon />
                  <Typography
                    style={{
                      width: '19.13px',
                      height: '19.13px',
                      backgroundColor: '#F64646',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#FFFFFF',
                      fontFamily: 'Poppins',
                      fontSize: '12.92px',
                    }}
                    sx={{ marginTop: '2px' }}
                  >
                    {data?.exp}
                  </Typography>
                </Box>
              )}
            </TableCell>
            <TableCell
              align="center"
              style={{ width: '35%', padding: 0, borderBottom: 'none' }}
            >
              <Stack direction="column" spacing={1} alignItems="center">
                {data?.buyerOffer && (
                  <BadgeButton
                    offerStatus={data?.buyerOffer?.offerStatus}
                    isnew={data?.buyerOffer?.isNew}
                  />
                )}

                {data?.buyerOffer?.offerStatusVendor && (
                  <BadgeButton
                    offerStatus={data?.buyerOffer?.offerStatusVendor}
                    isnew={data?.buyerOffer?.isNewVendor}
                  />
                )}
              </Stack>
            </TableCell>
            <TableCell
              align="right"
              style={{ width: '30%', borderBottom: 'none' }}
            >
              <Box>
                <Typography>
                  <Box aria-describedby={id} onClick={handleClicke}>
                    <Button
                      onClick={handleClicke}
                      sx={[
                        menuitemfont,
                        {
                          ...poppins500,
                          fontSize: '12px',
                          border: '1px solid #6C2AD2',
                          '.MuiOutlinedInput-notchedOutline': { border: 0 },
                          outline: 'none',
                          color: '#112347',
                          height: '30px',
                          width: '83px',
                          borderRadius: '5px',
                          textTransform: 'none',
                          whiteSpace: 'nowrap',
                          alignItems: 'center',
                          padding: '10px',
                        },
                      ]}
                    >
                      Action &nbsp;
                      <SelectDownIcon />
                    </Button>
                  </Box>
                  <Popover
                    id={id}
                    open={openn}
                    anchorEl={anchorEl}
                    onClose={handleClosee}
                    PaperProps={{
                      style: {
                        boxShadow: 'none',
                        border: '1px solid #D9D9D9',
                        borderRadius: '4px',
                        minWidth: '84px',
                      },
                    }}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                  >
                    <Typography>
                      <MenuItem
                        onClick={handleClosee}
                        value={10}
                        sx={{
                          ...poppins500,
                          fontSize: '12px',
                          color: '#112347',
                          alignItems: 'center',
                          justifyContent: 'left',
                        }}
                      >
                        Action
                      </MenuItem>
                    </Typography>
                    <Typography>
                      <MenuItem
                        onClick={handleClosee}
                        value={10}
                        sx={{
                          ...poppins500,
                          fontSize: '12px',
                          color: '#112347',
                          alignItems: 'center',
                          justifyContent: 'left',
                        }}
                      >
                        Twenty
                      </MenuItem>
                    </Typography>
                    <Typography>
                      <MenuItem
                        onClick={handleClosee}
                        value={10}
                        sx={{
                          ...poppins500,
                          fontSize: '12px',
                          color: '#112347',
                          alignItems: 'center',
                          justifyContent: 'left',
                        }}
                      >
                        Thirty
                      </MenuItem>
                    </Typography>
                  </Popover>
                </Typography>
              </Box>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: isSm ? '5px 11px' : '15px 20px 15px 11px',
          width: matchessm ? '100%' : '335px',
          height: '146px',
          border: '1px solid #E7E5E5',
          borderRadius: '8px',
        }}
      >
        {buyerCardLoading && (
          <Grid
            sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '160px 0',
            }}
          >
            <img
              alt="Logo"
              src={Loading}
              className="loaderImage"
              style={{ height: '50px', width: '50px' }}
            />
          </Grid>
        )}
        {!buyerCardLoading && (
          <Box sx={{ overflowWrap: 'anywhere' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Avatar
                src={Phone}
                sx={{
                  borderRadius: '0px',
                  width: '30px',
                  height: '30px',
                  marginBottom: '10px',
                }}
              />

              <Typography
                sx={{
                  ...poppins400,
                  fontSize: '12px',
                  color: '#585858',
                  marginLeft: isSm ? '9px' : '17px',
                  marginTop: '6px',
                }}
              >
                {data?.userMobile}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Avatar
                src={Mail}
                sx={{
                  borderRadius: '0px',
                  width: '30px',
                  height: '30px',
                  marginBottom: '10px',
                }}
              />

              <Typography
                variant="body1"
                sx={{
                  ...poppins400,
                  fontSize: matches870 ? '10px ' : '12px',
                  color: '#585858',
                  marginLeft: isSm ? '9px' : '17px',
                  marginTop: '6px',
                }}
              >
                {data?.userEmail}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Avatar
                src={Location}
                sx={{
                  borderRadius: '2px',
                  width: '30px',
                  height: '30px',
                }}
              />
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: '12px',
                  color: '#585858',
                  marginLeft: isSm ? '9px' : '17px',
                  marginTop: '8px',
                }}
              >
                {data?.userAddress ? data?.userAddress : 'Address not found'}
              </Typography>
            </Box>
          </Box>
        )}
        {currentPage.includes('/view-dashboard') &&
          !expand &&
          !buyerCardLoading && (
            <Box
              sx={{
                marginLeft: matches870 ? '50px' : '10px',
              }}
            >
              <Typography
                sx={displayFlex}
                style={{
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                  width: isSm && !show ? '48%' : null,
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: matchessm ? '10px' : '12px',
                    fontWeight: matchessm ? '300' : 'auto',
                    mb: '5px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Buyer match
                </Typography>
                <CircularProgressWithProfile value={data?.profileActivity} />
              </Typography>
            </Box>
          )}
        {currentPage.includes('/People') &&
          !isHidden &&
          !expand &&
          !buyerCardLoading && (
            <Box
              sx={{ bottom: '10px', marginLeft: '54px', position: 'sticky' }}
            >
              <Typography>
                <Select
                  sx={{
                    ...poppins500,
                    fontSize: '12px',
                    color: '#112347',
                    boxShadow: ' 0px 1px 4px rgba(0, 0, 0, 0.15)',
                    background: '#FFFFFF',
                    border: '1px solid #6C2AD2',
                    height: '30px',
                    borderRadius: '5px',
                  }}
                  size="medium"
                  value="10"
                  style={{
                    padding: '0px',
                  }}
                  onChange={() => {}}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem
                    value={10}
                    sx={{
                      ...poppins500,
                      fontSize: '12px',
                      color: '#112347',
                    }}
                  >
                    Action
                  </MenuItem>
                  <MenuItem
                    value={20}
                    sx={{
                      ...poppins500,
                      fontSize: '12px',
                      color: '#112347',
                    }}
                  >
                    Twenty
                  </MenuItem>
                  <MenuItem
                    value={30}
                    sx={{
                      ...poppins500,
                      fontSize: '12px',
                      color: '#112347',
                    }}
                  >
                    Thirty
                  </MenuItem>
                </Select>
              </Typography>
            </Box>
          )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          padding: '0',
          gap: '20px',
          width: matchessm ? '100%' : '340px',
          height: '59px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '8px',
            width: '45%',
            height: '100%',
            background: 'rgba(108, 42, 210, 0.1)',
          }}
        >
          <Typography
            sx={{ ...poppins500, fontSize: '16px', color: '#6C2AD2' }}
          >
            {data?.noOfOffers}
          </Typography>
          <Typography
            sx={{ ...poppins400, fontSize: '10px', color: '#666666' }}
          >
            Active
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            height: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '8px',
            width: '45%',
            backgroundColor: 'rgba(47, 205, 255, 0.12)',
          }}
        >
          <Typography
            sx={{ ...poppins500, fontSize: '16px', color: ' #2FCDFF' }}
          >
            {data?.previouslyOfferMade}
          </Typography>
          <Typography
            sx={{ ...poppins400, fontSize: '10px', color: '#666666' }}
          >
            Offer previously Made
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
